<template lang="pug">
    .wrapper
        .header
          .titulo(v-if="label" ) {{ label }}
          .icone-chapado-editar(v-if="podeEditar" title="editar" @click="habilitarEdicao")
        input(v-if="allowFilter" type="text" :placeholder="filterLabel" class="search" v-model.trim="parametroBusca")
        .inner-content(:style="`max-height: ${maxHeight}; min-height: ${disabled ? '0' : maxHeight};`" :class="disabled ? 'disabled' : '' " ref="conteudo")
            .itens-container(v-if="!allowLoadMoreItens")
                .item(v-for="item in filteredItem" :key="item.id")
                    input(
                      type="checkbox"
                      :value="item"
                      :id="item.id"
                      :disabled="disabled"
                      v-model="checkedValues"
                      )
                    label(:for="item.id" class="item-label") {{item[itemRef] ? item[itemRef] : item}}
            .itens-container(v-else)
                .item(v-for="item in filteredAllowedExtraItens" :key="item.id")
                    input(
                      type="checkbox"
                      :value="item"
                      :id="item.id"
                      :disabled="disabled"
                      v-model="checkedValues"
                      )
                    label(:for="item.id ? item.id : item" class="item-label") {{item[itemRef] ? item[itemRef] : item}}

</template>

<script>
export default {
  name: 'MultiSeletor',
  props: {
    maxHeight: {type: String, required: false, default: '120px'},
    label: {type: String, required: false},
    items: {required: true},
    itemRef: {type: String, required: true},
    allChecked: {type: Boolean},
    disabled: {type: Boolean, default: false},
    allowLoadMoreItens: {type: Boolean, default: false},
    allowedExtraItens: {type: Array},
    allowFilter: {type: Boolean, default: true},
    filterLabel: {type: String, default: ''},
    faltaItems: {type: Boolean, default: false},
    podeEditar: {type: Boolean, default: false}
  },
  beforeMount () {
    // Quando o componente for criado e na primeira verificacao ele estiver desabilitado,
    // significa que temos valores já renderizados, esperando serem confirmados. Sendo assim,
    // cria-se um 'backup' para esses valores, para ter armazenado os valores iniciais, caso
    // o usuário faça alteraçoes

    if (this.$props.disabled) {
      this.backupValues = this.$props.items
    }
    if (this.$props.allChecked) {
      this.checkedValues = this.$props.items
    }
  },
  mounted () {
    this.$refs.conteudo.addEventListener('scroll', e => {
      const conteudo = e.target
      const ehFimDoScroll = (conteudo.scrollHeight - conteudo.scrollTop) === conteudo.clientHeight

      if (ehFimDoScroll) {
        if (this.$props.faltaItems) {
          this.$emit('buscarMaisItens')
        }
      }
    })
  },
  data () {
    return {
      backupValues: [],
      checkedValues: [],
      parametroBusca: ''
    }
  },
  computed: {
    filteredItem () {
      if (this.parametroBusca) {
        const parametroBusca = this.parametroBusca.toLowerCase()
        return this.$props.items.filter(item => item[this.$props.itemRef].toLowerCase().includes(parametroBusca))
      }
      return this.$props.items
    },
    filteredAllowedExtraItens () {
      if (this.parametroBusca) {
        const parametroBusca = this.parametroBusca.toLowerCase()
        return this.$props.allowedExtraItens.filter(item => item[this.$props.itemRef].toLowerCase().includes(parametroBusca))
      }
      return this.$props.allowedExtraItens
    }
  },
  methods: {
    habilitarEdicao () {
      this.$emit('habilitarEdicao')
    }
  },
  watch: {
    checkedValues: {
      deep: true,
      handler (currentValue) {
        this.$emit('checkedValues', currentValue)
      }
    },
    items: {
      deep: true,
      handler () {
        if (this.$props.allChecked) {
          this.checkedValues = this.$props.items
        }
      }
    },
    disabled () {
      this.parametroBusca = ''
    }
  }
}
</script>

<style scoped>
.wrapper {
    width: 100%;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.375rem;
}
.header .icone-chapado-editar {
  cursor: pointer;
}
.header .titulo {
  font-weight: 700;
}
.inner-content  {
    width: inherit;
    background-color: white;
    overflow-y: scroll;
    scroll-behavior: smooth;
    border: 1px solid #ccc;
}
.inner-content.disabled {
    background-color: #f5f5f5;
    cursor:not-allowed;
    border: none;
}
.search {
  width: 100%;
  border: 1px solid #ccc;
  outline: none;
  min-height: 50px;
  margin-bottom: 2px;
}
.itens-container {
    padding: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
}
.itens-container .item {
    text-align: left;
}
.itens-container .item .item-label{
    padding-left: 1rem;
}
</style>
